const WINDOWS = [
  { id: "d30", label: "Days 0 – 30", caption: "Stabilise & identify" },
  { id: "d60", label: "Days 31 – 60", caption: "Repair & prepare" },
  { id: "d90", label: "Days 61 – 90", caption: "Review & verify" }
];

export function ReportActionPlan({ plan }) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {WINDOWS.map((window, idx) => (
        <div
          key={window.id}
          className="flex flex-col gap-3 rounded-sm border border-border bg-card p-5"
        >
          <div>
            <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
              {window.label}
            </p>
            <p className="mt-0.5 font-display text-base font-medium text-foreground">
              {window.caption}
            </p>
          </div>
          <ol className="space-y-2 text-sm leading-relaxed text-foreground">
            {plan[window.id].map((item, i) => (
              <li
                key={`${window.id}-${i}-${item.slice(0, 24)}`}
                className="flex items-start gap-2"
              >
                <span className="font-mono-label mt-0.5 text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                  {String(idx + 1)}.{String(i + 1).padStart(2, "0")}
                </span>
                <span>{item}</span>
              </li>
            ))}
          </ol>
        </div>
      ))}
    </div>
  );
}
